import type { NegotiationStrategy } from '@shared/graphql/hooks/negotiationStrategy/useNegotiationStrategies';

export const DEFAULT_OPTION_VALUE = '__default__';
export const NEVER_BUDGE_INLINE_ID = '__never_budge_inline__';

const EXCLUDED_STRATEGY_TYPES = ['CONDITIONAL', 'AB_TEST'];

export function getSelectableMovementOverrideStrategies(
  strategies: NegotiationStrategy[],
  currentStrategyId?: string
): NegotiationStrategy[] {
  return strategies.filter(
    (strategy) =>
      !EXCLUDED_STRATEGY_TYPES.includes(strategy.type) &&
      (strategy.active || strategy.id === currentStrategyId)
  );
}

export function getMovementOverrideDropdownStrategies(
  strategies: NegotiationStrategy[],
  hasOrgNeverBudge = strategies.some(
    (strategy) => strategy.type === 'NEVER_BUDGE'
  )
): NegotiationStrategy[] {
  if (hasOrgNeverBudge || strategies.length === 0) {
    return strategies;
  }

  return [
    ...strategies,
    {
      id: NEVER_BUDGE_INLINE_ID,
      name: 'Never Budge',
      type: 'NEVER_BUDGE',
      active: true,
      config: { type: 'NEVER_BUDGE' },
    } as NegotiationStrategy,
  ];
}
